var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teams-sec my-0"},[_c('ul',{staticClass:"chat-selection"},[_c('li',[_c('a',{staticClass:"text-capitalize active"},[_vm._v(_vm._s(_vm.selectedRoomTeam.teamName)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }